import React from "react";

function SearchInput({
  value,
  onChange,
  placeholder = "Search",
  ariaLabel = "Search",
}) {
  return (
    <div className="search-input-wrapper">
      <input
        type="search"
        placeholder={placeholder}
        aria-label={ariaLabel}
        className="search-input"
        value={value}
        onChange={onChange}
      />
      <i className="fas fa-search" />
    </div>
  );
}

export default SearchInput;
